export const dropbox = () => (
  <path
    d="M12.0142 6.51316L6.50712 10.0263L12.0142 13.5395L6.50712 17.0527L1 13.5205L6.50712 10.0073L1 6.51316L6.50712 3L12.0142 6.51316ZM6.47864 18.1826L11.9858 14.6694L17.4929 18.1826L11.9858 21.6957L6.47864 18.1826ZM12.0142 13.5205L17.5214 10.0073L12.0142 6.51316L17.4929 3L23 6.51316L17.4929 10.0263L23 13.5395L17.4929 17.0527L12.0142 13.5205Z"
    fill="#0061FF"
  />
);
